import React from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaFileAlt, 
    FaFileContract, 
    FaFolderOpen,
    FaArrowLeft,
    FaArrowRight
} from 'react-icons/fa';

const EngineerWorkReportsMenu = () => {
    const navigate = useNavigate();

    const ActionCard = ({ title, subtitle, icon, onClick, colorClass, iconColor }) => (
        <div 
            onClick={onClick}
            className="group cursor-pointer bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col items-start overflow-hidden h-full"
        >
            <div className={`h-1.5 w-full ${colorClass}`}></div>
            <div className="p-8 flex flex-col items-start space-y-6 flex-grow">
                <div className={`p-4 rounded-xl ${iconColor} bg-opacity-10 transition-transform duration-500 group-hover:scale-110 shadow-sm`}>
                    <div className={`text-3xl ${iconColor.replace('bg-', 'text-')}`}>
                        {icon}
                    </div>
                </div>
                <div>
                    <h3 className="text-xl font-bold text-gray-800 tracking-tight mb-2">
                        {title}
                    </h3>
                    <p className="text-gray-400 text-sm font-bold">
                        {subtitle}
                    </p>
                </div>
            </div>
            <div className="w-full h-12 px-8 flex items-center justify-between border-t border-gray-50 bg-gray-50/30 group-hover:bg-gray-50 transition-colors">
                <span className="text-gray-400 text-xs font-bold uppercase tracking-widest">निवडा</span>
                <FaArrowRight className="text-gray-300 group-hover:text-gray-600 transition-colors" size={14} />
            </div>
        </div>
    );

    return (
        <EngineerLayout>
            <div className="p-6 md:p-8 bg-gray-50/30 min-h-screen">
                {/* Dark Header Card */}
                <div className="bg-[#1a1c23] rounded-3xl p-10 mb-12 shadow-2xl relative overflow-hidden group">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32 blur-3xl transition-transform duration-1000 group-hover:scale-110"></div>
                    <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#085e53]/10 rounded-full -ml-16 -mb-16 blur-2xl"></div>
                    
                    <div className="relative flex flex-col md:flex-row justify-between items-center gap-6">
                        <div className="flex items-center gap-6">
                            <button 
                                onClick={() => navigate('/engineer/work-names')}
                                className="bg-white/10 hover:bg-white/20 text-white p-4 rounded-2xl transition-all hover:scale-110 active:scale-90 backdrop-blur-sm border border-white/10"
                            >
                                <FaArrowLeft size={18} />
                            </button>
                            <div>
                                <h1 className="text-4xl font-bold text-white tracking-tight mb-3">कामाचे अहवाल (Work Reports)</h1>
                                <p className="text-gray-400 font-bold text-sm tracking-widest uppercase">
                                    खालीलपैकी एक अहवाल पर्याय निवडा
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    <ActionCard 
                        title="सुबे हस्तांतरण कामे" 
                        subtitle="सुबे हस्तांतरण कामांची यादी आणि तपशील"
                        icon={<FaFileAlt />} 
                        onClick={() => navigate('/engineer/sume-transfer-work-list')}
                        colorClass="bg-[#8b5cf6]"
                        iconColor="bg-[#8b5cf6]"
                    />
                    <ActionCard 
                        title="मजूर हस्तांतरण कामे" 
                        subtitle="मजूर हस्तांतरण कामांची यादी आणि तपशील"
                        icon={<FaFileContract />} 
                        onClick={() => navigate('/engineer/society-transfer-work-list')}
                        colorClass="bg-[#f97316]"
                        iconColor="bg-[#f97316]"
                    />
                    <ActionCard 
                        title="खुला वर्ग कामे" 
                        subtitle="खुला वर्ग कामांची यादी आणि तपशील"
                        icon={<FaFolderOpen />} 
                        onClick={() => navigate('/engineer/other-transfer-works')}
                        colorClass="bg-[#10b981]"
                        iconColor="bg-[#10b981]"
                    />
                </div>
            </div>
        </EngineerLayout>
    );
};

export default EngineerWorkReportsMenu;
